import React, { useEffect, useRef, useState } from 'react';

const Button = ({
  children,
  className,
  type = 'button',
  onClick,
  disabled
}) => {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const btnRef = useRef();
  useEffect(() => {
    setIsBtnDisabled(disabled);
  }, [disabled]);
  const onClickHandler = e => {
    if (e.target.type === 'submit') {
      return;
    }
    if (isBtnDisabled || disabled) {
      return;
    }
    if (btnRef.current) {
      setIsBtnDisabled(true);
    }
    if (onClick) {
      onClick(e);
    } else {
      e.currentTarget.click();
    }
  };
  return (
    <button
      ref={btnRef}
      type={type}
      disabled={isBtnDisabled}
      onClick={onClickHandler}
      className={`${className}${
        isBtnDisabled ? ` ${className.split(' ')[0]}--disabled` : ' '
      }`}
    >
      {children}
    </button>
  );
};

export default Button;
